import React from 'react'
import { connect } from 'react-redux'
import users from '../../../../../lib/api/users'
import UserFollowing from '../../../../../lib/api/userFollowing'
import isNil from 'lodash/isNil'
import ConfirmRemoval from '../friends-list/unfollowPopup'
import FriendCard from '../friends-list/friendsListComponent'

class FindFriends extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      searchResults: [],
      searchStr: '',
      unfollowPopup: false,
      selectedFriend: [],
      spinner: false
    }
    this.searchPending = false
    this.containerRef = React.createRef()
  }

  handleFollow(user) {
    const { followingThem, id } = user,
      { auth } = this.props
    if (followingThem) {
      UserFollowing.remove({ userId: id, token: auth.token })
        .then(() => {
          const stateUser = this.state.searchResults.find(stateUser => stateUser.id === id)
          stateUser.followingThem = false
          this.forceUpdate()
          this.setState({ unfollowPopup: false })
        })
        .catch((err) => {
          console.error('find-friends remove failed', err)
        })
    } else {
      UserFollowing.add({ userId: id, token: auth.token })
        .then(() => {
          const stateUser = this.state.searchResults.find(stateUser => stateUser.id === id)
          stateUser.followingThem = true
          this.forceUpdate()
        })
        .catch(err => {
          console.error('find-friends add failed', err)
        })
    }
  }

  makeCard(user) {
    const imageUrl = !isNil(user.imageProfileUrl) ?
      user.imageProfileUrl : !isNil(user.thumbnailUrl) ? user.thumbnailUrl :
        '../../../../../../asset/Avatar_BaseMap-User_Default@1x.png'
    return (
      <div key={user.id} className='friend-card-base'>
        <img className='friend-card-profile-image' src={imageUrl}></img>
        <div style={{ height: '40px', width: 160 }}>
          <p className='friend-card-name' title={user.fullName}>{user.fullName}</p>
          <p style={{ fontSize: '10px', textAlign: 'center' }}>
            {user.followingMe ? 'Following Me' : 'Not Following Me'}</p>
        </div>
        <button className={user.followingThem ? 'friend-card-unfollow-button' : 'friend-card-follow-button-top'}
          onClick={() => {
            if (user.followingThem) {
              this.setState({ unfollowPopup: true, selectedFriend: user })
            } else {
              this.handleFollow(user)
            }
          }}
        >{user.followingThem ? 'Unfollow' : 'Follow'}</button>
      </div >
    )
  }

  search() {
    const { searchStr } = this.state,
      { token } = this.props.auth
    this.setState({ spinner: true })
    if (!this.searchPending) {
      this.searchPending = true
      users.search({ searchStr, token })
        .then(res => {
          this.setState({ searchResults: res }, () => {
            this.searchPending = false
            this.setState({ spinner: false })
            if (searchStr !== this.state.searchStr) {
              this.search()
            }
          })
        })
        .catch(err => {
          console.error('findFriends search error', err)
          this.searchPending = false
        })
    }
  }

  onChange(e) {
    this.setState({
      searchStr: e.target.value
    }, () => {
      const { searchStr } = this.state
      if (searchStr.length > 2 && !this.searchPending) {
        this.search()
      }
    })
  }

  render() {
    const { searchResults, searchStr, unfollowPopup, selectedFriend, spinner } = this.state,
      style = {}
    if (this.containerRef.current !== null) {
      const bounds = this.containerRef.current.getBoundingClientRect()
      style.height = `calc(100vh - ${bounds.top}px)`
    }
    return (
      <div>
        <div className='friends-search-container'>
          <i className="material-icons"
            style={{ fontSize: '18px', verticalAlign: 'middle', textAlign: 'center' }}>
            search
          </i>
          <input type='search'
            className='friends-search'
            value={searchStr}
            placeholder='Find Basemap Users'
            onChange={this.onChange.bind(this)}></input>
        </div>
        <div style={{ height: style.height, overflowY: 'auto' }} className='friend-list-scroll' ref={this.containerRef}>
          {/* {!spinner && searchResults.map(user => this.makeCard(user))} */}
          {!spinner && searchResults.map(friend => (
            <FriendCard
              key={friend.id}
              user={friend}
              removeFriend={() => removeFriend(friend)}
              unfollowPopup={(user) => this.setState({ unfollowPopup: true, selectedFriend: user })}
              handleFollow={() => this.handleFollow((friend))}
            />
          ))}
        </div>
        {spinner && <div class="friends-loader"></div>}

        {unfollowPopup &&
          <ConfirmRemoval remove={() => this.handleFollow(selectedFriend)} userData={this.state.selectedFriend} cancel={() => { this.setState({ unfollowPopup: false }) }}></ConfirmRemoval>
        }

      </div >
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth
})

const mapDispatchToProps = dispatch => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(FindFriends)